import type { TrackingTraits } from '@chilipiper/web-data-external'
import { logger } from './logger'

const isTraitValue = (value: unknown): value is string | number | boolean | null =>
  value === null ||
  typeof value === 'string' ||
  typeof value === 'boolean' ||
  (typeof value === 'number' && Number.isFinite(value))

/**
 * Keeps `identify()` payloads flat and JSON-safe: customer pages pass arbitrary objects, and nested
 * values or functions would either fail serialization or land as unusable columns in the warehouse.
 * Returns undefined when nothing usable is left, so callers can skip the identify call entirely.
 */
export const sanitizeTraits = (input: unknown): TrackingTraits | undefined => {
  if (typeof input !== 'object' || input === null || Array.isArray(input)) {
    logger.warn('identify() expects an object of flat key/value traits')
    return undefined
  }

  const traits: TrackingTraits = {}
  for (const [key, value] of Object.entries(input)) {
    if (!key.trim()) continue
    if (isTraitValue(value)) {
      traits[key] = value
    } else {
      logger.warn(
        `identify(): dropped trait "${key}" — only string, number, boolean or null values are sent`
      )
    }
  }

  return Object.keys(traits).length > 0 ? traits : undefined
}
